export default Object.freeze({
  LOGIN_REDIRECT_URI: '/user/auth/fottorama/callback/login',
  LOGOUT_REDIRECT_URI: '/user/auth/fottorama/callback/logout'
})
